<template>
  <div id="app">
	<top />
	<HomeBanner />
	<news />
	<Entrance />
	<bottom />
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import HomeBanner from './components/HomeBanner.vue'
import Entrance from './components/Entrance.vue'
import news from './components/news.vue'
import top from './components/top.vue'
import bottom from './components/bottom.vue'

export default {
  name: 'app',
  components: {
    HelloWorld,
	HomeBanner,
	Entrance,
	news,
	bottom,
	top
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0px;
}
</style>
